import { useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";

const SX_BASE_LEGAL = {
  width: "280px",
  "& .MuiOutlinedInput-root": { borderRadius: "8px", "& fieldset": { borderColor: "divider" } },
};

// Estáveis (fora do componente): o Autocomplete reseta o texto digitado quando estas funções
// mudam de identidade entre renders.
const rotuloDaOpcao = (o) => o?.label ?? "";
const mesmaOpcao = (a, b) => a?.id === b?.id;

/**
 * Base legal da rúbrica na lista: dropdown no modelo dos filtros do sistema (Autocomplete),
 * com busca por digitação. "Selecione" = sem base legal (a rúbrica sai do projeto).
 * Base legal desativada/removida do catálogo continua como opção, para não zerar em silêncio
 * a seleção da rúbrica.
 *
 * @param {{ baseLegalId: number|null, baseLegalDescricao: string|null,
 *   basesLegais: Array<{id: number, descricao: string}>, disabled?: boolean,
 *   onChange: (id: number|null) => void, ariaLabel: string }} props
 */
export default function DropdownBaseLegal({
  baseLegalId,
  baseLegalDescricao,
  basesLegais,
  disabled,
  onChange,
  ariaLabel,
}) {
  const opcoes = useMemo(() => {
    const lista = [{ id: null, label: "Selecione" }];
    if (baseLegalId != null && !basesLegais.some((b) => b.id === baseLegalId)) {
      lista.push({ id: baseLegalId, label: baseLegalDescricao || `Base Legal #${baseLegalId}` });
    }
    basesLegais.forEach((b) => lista.push({ id: b.id, label: b.descricao }));
    return lista;
  }, [baseLegalId, baseLegalDescricao, basesLegais]);

  const selecionada = opcoes.find((o) => o.id === baseLegalId) ?? opcoes[0];

  return (
    <span title={baseLegalDescricao || "Sem base legal"}>
      <Autocomplete
        size="small"
        disableClearable
        disabled={disabled}
        value={selecionada}
        options={opcoes}
        onChange={(_, opt) => onChange(opt.id)}
        getOptionLabel={rotuloDaOpcao}
        isOptionEqualToValue={mesmaOpcao}
        renderInput={(params) => (
          <TextField {...params} inputProps={{ ...params.inputProps, "aria-label": ariaLabel }} />
        )}
        sx={SX_BASE_LEGAL}
      />
    </span>
  );
}
